import { render, staticRenderFns } from "./QueryProposal.vue?vue&type=template&id=16dd4462&"
import script from "./QueryProposal.vue?vue&type=script&lang=js&"
export * from "./QueryProposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports